export default __webpack_public_path__ + "static/bridge-b42946bbb11a5db6a1b07fc8e1ff261e.png";